import React from 'react';
import NavBar from '../../../components/layout/navbar';
import FormConfiguracao from '../../../components/configuracao/form-configuracao'

export default function TelaConfiguração(){
    return(
        <>
            <NavBar />
            <FormConfiguracao />
        </>
    )
}